<template>

  <div class="corretiva-lancamento ml-4 mr-4" >
      <b-form>          
          <b-row>        
            <LoadingModal v-if="isLoading" />    
              <!--               <b-col cols="2">
                <label for="select-empresa-cor">Empresa</label> 
                <multiselect  id="selecao-empresa-cor"  v-model="value_empresaf" required                  
                  :options="empresasf" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true" 
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="nomeempresarial" track-by="nomeempresarial" name="nomeempresarial"
              >                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>
              -->


              <b-col cols="2">
                <label for="select-filial_cor">Filial</label> 
                <multiselect id="selecao-filial-cor"  v-model="filialf.id_filial" required                   
                  :options="filiaisf" 
                  :multiple="true"                                    
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="2">
                <label for="select-garagem">Status</label>   
                <multiselect  v-model="value_status" required 
                  :options="statuss" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a status" label="status" track-by="status" name="status"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Status selecionado</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="2">
                <label for="select-tpcorretiva">Tipo de corretiva</label> 
                <multiselect  v-model="value_tipo" required 
                  :options="tipos"                   
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false"                   
                  :preserve-search="true"   placeholder="Selecione o tipo" label="tipo" track-by="tipo" name="tipo"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Status selecionado</span></template>
                </multiselect> 
              </b-col>
              
              <b-col cols="1 ">
                <div>                            
                  <label  for="datepicker-placeholder">Data de abertura</label>                        
                  <b-form-datepicker id="dt_sol_inicial"  required  v-model="dt_abertura" placeholder="Data inicial " locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

              <b-col cols="1">
                <br>                 
                <b-button  variant="primary" class="mr-2 mt-2" block @click="loadCorretivaMonitoramento()"> 
                   Pesquisar
                </b-button>                      
              </b-col>

              <b-col cols="3"  class="mb-0">
                <label  for="input-busca">Pesquisa no grid</label> 
                <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Carro ou RE"></b-form-input>              
              </b-col>                    

              <b-col cols="1">
                <br>                 
                <b-button  variant="success" class="mr-2 mt-2" block v-b-modal.modal-multi-corretiva @click="novo(),loadNovoNroCorretiva(),loadTipos()"> 
                   Novo
                </b-button>                      
              </b-col>
          </b-row>
      
      <b-row class="justify-content-center align-items-center">

        <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>

          

              <b-card                          
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="CORRETIVAS PENDENTES"
                header-bg-variant="danger"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                  {{ itemsFiltered.filter( s => s.status === 'PENDENTE').length }}
                  </h2>
                </b-card-text>
              </b-card>
            
            <b-card                  
              class="ml-2"
              style="width: 33rem;"              
              border-variant="primary"
              header="CORRETIVAS EM ATENDIMENTO"
              header-bg-variant="warning"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ itemsFiltered.filter( s => s.status === 'EM SERVIÇO').length }}
                </h2>               
                
              </b-card-text>
            </b-card>

            <b-card                  
            class="ml-2"
                style="width: 33rem;"
              
              border-variant="primary"
              header="CORRETIVAS FINALIZADAS"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ itemsFiltered.filter( s => s.status === 'FINALIZADA').length }}
                </h2>                
              </b-card-text>
      </b-card>        

          <b-card
          class="ml-2"
                style="width: 33rem;"
            border-variant="primary"
            header="TOTAL DE CORRETIVAS "
            header-bg-variant="primary"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{itemsFiltered.length}}
              </h2>              
            </b-card-text>
          </b-card>
      </b-card-group> 
      </b-row>
      
    </b-form>
      


    <!--tbl de dados -->
    <b-table id="tbldefeitos"  small hover striped sticky-header="660px"  :items="itemsFiltered" :fields="situacaocorretiva" >    
        <template slot="cell(actions)" slot-scope="data"  >

          <b-button @click="editCorretivaCabecalho(data.item) " v-b-modal.modal-multi-corretiva title="Editar Corretiva"  size="sm" variant="success" class="mr-2">                
              <i class="fa fa-exclamation-circle"></i>
          </b-button>

          <!--
            <b-button @click="editCorretivaCabecalho(data.item),loadGrupo_d(), loadGrupo_i(), loadCorretivaAnalitica()" v-b-modal.modal-multi-corretiva title="Liberar p/ operação"  size="sm" variant="warning" class="mr-2">                
                <i class="fa fa-bus"></i>
            </b-button>
          -->

        </template>   
        
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div >        
    <b-modal id="modal-multi-corretiva"  hide-footer size="xl" centered  title="Cadastro de ficha corretiva "  @close="novo()" no-close-on-esc no-close-on-backdrop  >
          <!-- -->
          <div >

          <!-- EMPRESA FILIAL --> 
            <b-row id="defeito-selecao" >
                <b-col cols="4">
                <label for="input-garagem">Empresa</label>  <!-- {{corretiva.id_filial}} -->
                <div>                
                  <b-form-select   
                    id="garagem"    
                    
                    v-model="corretiva.empresa_id"                    
                    required                                                   
                    :options="empresas"
                    @change="loadFiliaisCad()"
                    class="mb-3 "
                    text-field="empresa"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="4">
                <label for="input-garagem">Filial</label>  <!-- {{corretiva.id_filial}} -->
                <div>                
                  <b-form-select   
                    id="garagem"    
                    
                    v-model="corretiva.filial_id"                    
                    required                                                   
                    :options="filiais"
                    @change="loadLinhas(), loadGrupo_i(),loadGrupo_d()"
                    class="mb-3 "
                    text-field="filial"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>


            <b-col cols="2">
                <label for="input-live">Nº da corretiva</label>     
                <b-input-group-text >{{nrocorretiva.length > 0 ? nrocorretiva : corretiva.id }}</b-input-group-text>
            </b-col> 

            <b-col cols="2">                                              
                  <b-form-checkbox
                    id="corretiva-liberado" 
                    class="mb-3 mt-5"
                    v-model="corretiva.liberou_operacao"                  
                    name="checkbox-2"
                    value="true"
                    unchecked-value="false"
                    checked="true"
                  >                  
                  Lib. para operação  
                  </b-form-checkbox>                
            </b-col>





            </b-row>
             
              <!-- seleção --> 
            <b-row id="defeito-selecao" >
             <b-col cols="2" >
                <label for="input-live">Solicitante</label> 
                <b-form-input v-model="corretiva.operador" @keyup.enter="loadOperador()" required placeholder="RE"></b-form-input>              
              </b-col> 


              <b-col cols="2">
                <label for="input-live">Função  </label>                 
                <b-input-group-text >{{ operador.funcao ? operador.funcao : '-' }}</b-input-group-text>
              </b-col> 



              <b-col cols="2">

                <label for="input-garagem"> Tipo de corretiva</label>                 
                <div>                
                  <b-form-select   
                    id="tpcorretiva"               
                    v-model="corretiva.tipo_id"                    
                    required                                                   
                    :options="tipos"

                    class="mb-3 "
                    text-field="tipo"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="2"  class="mb-3">
                <label for="input-live">Carro</label> 
                <b-form-input v-model="corretiva.carro" @keyup.enter="loadVeiculo()" required="required" placeholder="Nro carro"></b-form-input>              
              </b-col> 

              <b-col cols="2">
                <label for="input-live">Placa</label>     
                <b-input-group-text > {{ veiculos.map(at => at.placa).join(', ') }} </b-input-group-text>
              </b-col> 

            <b-col cols="2">
                <label for="input-garagem"> Linha</label>  
                <div>                
                  <b-form-select   
                    id="tipo"               
                    v-model="corretiva.linha_id"                                          
                    required                                                   
                    :options="linhas"
                    class="mb-3 "
                    text-field="linha"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>
            
            </b-row>

            <!--  via_cep  --->
            <b-row id="id-sos" v-if="tipos.some(item => item.id === corretiva.tipo_id && item.sos === true)" class="pt-1 pb-1">            
              <b-col cols="2"  class="mb-2">
                <label for="input-live">CEP S.O.S</label> <!-- {{  user.id_funcionario_erp  }} -->
                <b-form-input v-model="corretiva.cep" @keyup.enter="loadCep()" required placeholder="Cep"></b-form-input>              
              </b-col>

              <b-col cols="4"  class="mb-2">
                <label for="input-live">Logradouro</label> 
                <b-form-input v-model="viacep.logradouro"  required="required" placeholder="Rua"></b-form-input>              
              </b-col> 

              <b-col cols="1"  class="mb-2">
                <label for="input-live">Número</label> 
                <b-form-input v-model="corretiva.numero" required placeholder="Nº"></b-form-input>              
              </b-col> 

              <b-col cols="2"  class="mb-2">
                <label for="input-live">Bairro</label> 
                <b-form-input v-model="viacep.bairro" placeholder="Bairro"></b-form-input>              
              </b-col> 

              <b-col cols="2"  class="mb-2">
                <label for="input-live">Cidade</label> 
                <b-form-input v-model="viacep.localidade" required placeholder="Cidade"></b-form-input>              
              </b-col> 

              <b-col cols="1"  class="mb-2">
                <label for="UF">U.F</label> 
                <b-form-input v-model="viacep.uf" required placeholder="Uf"></b-form-input>              
              </b-col>               
            <!-- obs sos -->

              <b-col cols="2" >
                <label for="input-live">Socorrista</label> 
                <b-form-input v-model="corretiva.socorrista" @keyup.enter="loadSocorrista()" required placeholder="RE"></b-form-input>              
              </b-col> 

              <b-col cols="2"  class="mb-2">  
                <label for="input-live">Carro Socorrista</label>  
                <b-form-input v-model="corretiva.carro_socorrista" @keyup.enter="loadVeiculoSocorrista()" required="required" placeholder="Nro carro"></b-form-input>              
              </b-col> 

              <b-col cols="2"  class="mb-2">
                <label for="input-live">Carro Trocado</label>  
                <b-form-input v-model="corretiva.carro_trocado" @keyup.enter="loadVeiculoTrocado()" required="required" placeholder="Nro carro"></b-form-input>              
              </b-col> 


              <b-col cols="6"  class="mb-0">
                <label for="input-live">Observações Socorrista</label>  
                <b-form-input v-model="corretiva.socorrista_obs"  required="required" placeholder="Observações"></b-form-input>              
              </b-col> 
              
            
            </b-row>

            


            <!--defeito informado pelo operador --> 

            <b-row id="id-informado" class="pt-1 pb-1">
                              <b-col cols="3">
                <label for="input-grupo-defeito">Grupo informado</label>  {{defeito.grupoi_id}}
                <div>                
                  <b-form-select   
                    id="grupo-defeito"               
                    v-model="defeito.grupoi_id"   
                    @change="loadSubGrupo_i()"                 
                    required                                                   
                    :options="gruposi"                    
                    class="mb-3 "
                    text-field="grupo"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

                              <b-col cols="4">
                <label for="input-subgrupo-defeito">Subgrupo informado</label>  {{defeito.subgrupoi_id}}
                <div>                
                  <b-form-select   
                    id="subgrupo-defeito"               
                    v-model="defeito.subgrupoi_id"                    
                    required                                                   
                    :options="subgruposi"
                    @change="loadDefeito_i()" 
                    
                    class="mb-3 "
                    text-field="subgrupo"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="5">
                <label for="input-defeito-defeito">Defeito informado</label> 
                <div>                
                  <b-form-select   
                    id="id-informado-defeito"               
                    v-model="defeito.defeitoi_id"                    
                    required                                                   
                    :options="defeitosi"                    
                    class="mb-3 "
                    text-field="defeito"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="6"  class="mb-0">
                <label  for="input-live">Observações do Reclamante</label> 
                <b-form-input v-model="defeito.observacoes_i"  required="required" placeholder="Observações"></b-form-input>              
              </b-col>

              <b-col cols="2" >
                <label for="input-live">Lider</label> 
                <b-form-input v-model="defeito.lider" @keyup.enter="loadLider()" required placeholder="RE"></b-form-input>              
              </b-col> 

              <b-col cols="2">
                <label for="input-live">Função Lider</label> 
                <b-form-input v-model="lideres.funcao" readonly placeholder="Função"></b-form-input>              
              </b-col>  

              
              <b-col cols="2">                                              
                  <b-form-checkbox
                    id="corretiva-defcancelado" 
                    class="mb-3 mt-5"
                    v-model="defeito.defeito_cancelado"                  
                    name="checkbox-2"
                    value="true"
                    unchecked-value="false"
                    checked="true"
                  >                  
                  Defeito Cancelado
                  </b-form-checkbox>                
              </b-col>


            </b-row>




            <!--defeito diagnosticado pelo execuntante da tarefa --> 

            <b-row id="id-diagnosticado" class="pt-1 pb-1">
                              <b-col cols="3">
                <label for="input-grupo">Grupo diagnosticado</label>  
                <div>                
                  <b-form-select   
                    id="garagem"               
                    v-model="defeito.grupod_id"  
                    @change="loadSubGrupo_d()"                  
                    required                                                   
                    :options="gruposd"
                    class="mb-3 "
                    text-field="grupo"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

                              <b-col cols="4">
                <label for="input-subgrupo">Subgrupo diagnosticado</label> 
                <div>                
                  <b-form-select   
                    id="garagem"               
                    v-model="defeito.subgrupod_id" 
                    @change="loadDefeito_d()"              
                    required                                                   
                    :options="subgruposd"
                    class="mb-3 "
                    text-field="subgrupo"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

                              <b-col cols="5">
                <label for="input-diagnosticado-defeito">Defeito diagnosticado</label> 
                <div>                
                  <b-form-select   
                    id="garagem"               
                    v-model="defeito.defeitod_id"                    
                    required                                                   
                    :options="defeitosd"
                    class="mb-3 "
                    text-field="defeito"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="6"  class="mb-0">
                <label  for="input-live">Observações do Executante</label> 
                <b-form-input v-model="defeito.observacoes_d"  required="required" placeholder="Observações"></b-form-input>              
              </b-col>

              <b-col cols="2" >
                <label for="input-live">Executante</label> 
                <b-form-input v-model="defeito.executante" @keyup.enter="loadExecutante()" required placeholder="RE"></b-form-input>              
              </b-col> 

              <b-col cols="2">
                <label for="input-live">Função Executante</label> 
                <b-form-input v-model="executantes.funcao" readonly placeholder="Função"></b-form-input>              
              </b-col> 






               <b-col cols="2">                                              
                  <b-form-checkbox
                    id="corretiva-causador" 
                    class="mb-0 mt-5 "
                    v-model="defeito.defeito_causador"                  
                    name="checkbox-2"
                    value="true"
                    unchecked-value="false"
                    checked="true"
                  >                  
                  Defeito Causador 
                  </b-form-checkbox>                
              </b-col>
             


            </b-row>


            <!-- fechamento -->
            <b-row id="id-encerramento" cols="10" class="mt-2">

              <b-col cols="2">
                <label for="input-live">Data Abertura</label>                 
                <b-input-group-text >{{ corretiva.dt_cadastro ? moment(corretiva.dt_cadastro).format('DD/MM/YYYY HH:mm').replace('Data inválida','-')  : '-'  }}</b-input-group-text>
              </b-col> 

              <b-col cols="2">                
                <label for="input-live">Data fechamento</label>                  
                 <b-input-group-text >{{ corretiva.dt_encerramento ? moment(corretiva.dt_encerramento).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') : '-' }}</b-input-group-text>
              </b-col> 

              <b-col cols="2">
                <label for="input-live">ERP Data importação</label> 
                <b-input-group-text >{{ corretiva.dt_jb_acesso ? moment(corretiva.dt_jb_acesso).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') : '-'  }}</b-input-group-text>                
              </b-col> 

              <b-col cols="2">
                <label for="input-live">ERP Nro Ficha</label> 
                <b-form-input v-model="lin.id_linha_erp" readonly placeholder="A18562022"></b-form-input>              
              </b-col> 

              <b-col cols="2">
                <label for="input-live">ERP Nro O.S</label> 
                <b-form-input v-model="lin.id_linha_erp"  readonly placeholder="ML28122022">  </b-form-input>              
              </b-col> 











              <b-col cols="1" class="mt-2 mb-2"> 
                <b-button class="mt-4" variant="success"   @click="encerrarCabecalho(),novo()">
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Encerrar
                </b-button>                      
              </b-col> 

              

              <b-col cols="1" class="mt-2 mb-2"> 
                <b-button class="mt-4" variant="danger"  :disabled="carregando" @click="reset()">                  
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Gravar
                </b-button>                      
              </b-col> 

            </b-row>

             <!-- defeitos da corretiva -->
            <b-table id="tbcorretivadefeitos"  small hover striped sticky-header="220px"  :items="corretivaeditdefeito" :fields="listcorretivadefeitos" >    
              <template slot="cell(actions)" slot-scope="data"  >
                <b-button @click="editCorretivaCorpo(data.item),loadExecutante(),loadLider()" title="Editar defeito"  size="sm" variant="success" class="mr-2">                
                  <i class="fa fa-exclamation-circle"></i>
                </b-button>
              </template>           
            </b-table>

          </div>          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>  

</template>

<script>
import { baseApiUrl, showError  } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { mapState } from 'vuex' 
import LoadingModal from '../utilitarios/LoadingModal'


export default {

    name: 'ManutencaoRfiLancamento', 
    
    /*
    computed: mapState(['user']),   
    */

    computed : { ... mapState (['user'],),
      itemsFiltered(){
        let valores = [];
       // const values = Object.values(obj);
        valores = this.corretivas.filter((item) =>{
          return (
            item.carro.indexOf(this.search) >-1  || item.operador.indexOf(this.search) >-1 
          );
        });
        return valores
        }       
    } ,


    data: function() {
      
      return {   
        isLoading: false,
        dt_abertura: '',
            empresas:[],
            filiais:[],

            empresasf:[],
            empresaf:{},
            filiaisf:[],
            filialf:{},
            veiculos:[],
            operador:[],            
            socorrista_carro:[],
            trocado_carro:[],
            socorristas:[],
            corretivas:[],
            corretiva:{},
            viacep:[],

            value_empresaf: [],



            defeitos:[],
            defeito:{},

            gruposi:[],
            subgruposi:[],
            defeitosi:[],
            
            gruposd:[],
            subgruposd:[],
            defeitosd:[],

            executante:{},
            executantes: [],  
            lider:{},
            lideres:[],





            mode: 'save',
            carregando: false,
            atualizando: false, 

            
            
            

            
            
            grupo:{},
            grupos:[],
            subgrupo:{},
            subgrupos:[],
            defeito:{},
            defeitos:[],

                        
           // gruposd:[],
            gruposd:{},
            subgrupod:{},
            subgruposd:[],
            defeitod:{},


            solicitante:{},
            solicitantes:[],


            socorrista:{},
            linhas:[],

            nrocorretiva:[],

            corretivaeditdefeito:[],
            
            

            statuss:[],
            situacaojb:[],

            value_carro:'',
            value_carro_socorrista:'',
            value_carro_trocado:'',
            value_cep:'',
            value_solicitante:'',
            value_executante:'', 
            value_socorrista:'',           
            value_status:[],
            value_statusjb:[],
            value_tipo:[],
            value_lider:'',
            

            //garagem:{},             
            tipos:[] ,
            search:'',


            

            lin:{},
            
            value_garagem:[],// [] lista                         
            
            
            value_observacoes:'',
           
          //  barra_inicial: 0,         
          //  barra_limite: 300000,
            
            situacaocorretiva: [      
                 
              { key: 'empresa_id', label: 'Empresa', sortable: true },                 
              { key: 'filial_id', label: 'Filial', sortable: true },                 
              { key: 'id', label: 'Nro Corretiva', sortable: true },  
              { key: 'tipo', label: 'Tipo Corretiva', sortable: true },
              { key: 'dt_cadastro', label: 'Data abertura', sortable: true, formatter: (value, key, corretivas) => {
                    return moment(corretivas.dt_cadastro).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },
              { key: 'qtd_defeito', label: 'Qtd defeitos', sortable: true },     
              { key: 'carro', label: 'Carro', sortable: true },                                
              { key: 'linha', label: 'Linha', sortable: true },                
              { key: 'operador', label: 'Reclamante', sortable: true },
              { key: 'status', label: 'Status', sortable: true },       
              { key: 'vlr_gasto', label: 'R$ gasto', sortable: true },                 
              { key: 'dt_encerramento', label: 'Data Encerramento', sortable: true, formatter: (value, key, corretivas) => {
                 return   moment(corretivas.dt_encerramento).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },      

                            { key: 'dt_alteracao', label: 'Data Alteração', sortable: true, formatter: (value, key, corretivas) => {
                    return moment(corretivas.dt_alteracao).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },

              { key: 'duracao2', label: ' Tempo Gasto', sortable: true },
              { key: 'situacao', label: 'ERP status', sortable: true },
              { key: 'dt_erp_integracao', label: 'Data Integração ERP', sortable: true, formatter: (value, key, corretivas) => {
                    return moment(corretivas.dt_erp_integracao).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },
              
                { key: 'actions', label: 'Ações' },                
              
            ],


            //////// defeitos da corretiva
            listcorretivadefeitos: [                
                { key: 'corretiva_id', label: 'Nro Corretiva', sortable: true },                 

                { key: 'id', label: 'Nro defeito', sortable: true },                 

                { key: 'grupoi', label: 'grupo informado', sortable: true },
                { key: 'subgrupoi', label: 'Subgrupo informado', sortable: true },
                { key: 'defeitoi', label: 'Defeito informado', sortable: true },                                
                { key: 'defeito_cancelado', label: 'Cancelado', sortable: true,formatter: value => value ? 'Sim' : 'Não'  },     

                { key: 'grupod', label: 'Grupo diagnosticado', sortable: true },                                                
                { key: 'subgrupod', label: 'Subgrupo diagnosticado', sortable: true },                                                
                { key: 'defeitod', label: 'Defeito diagnosticado', sortable: true },                 
                { key: 'defeito_causador', label: 'Causador', sortable: true,formatter: value => value ? 'Sim' : 'Não'  },
                
                { key: 'executante_defeito', label: 'Executante', sortable: true },                                                                           
                { key: 'dt_cadastro', label: 'Cadastro_defeito', sortable: true, formatter: (value, key, corretivaeditdefeito) => {
                    return moment(corretivaeditdefeito.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },                
                { key: 'actions', label: 'Ações' },                
            ]


        }        
    },

    filters: {
      dataFormatada(dt) {
        return dt.substring(0,4)
      }

    },

    components: {
        Multiselect,LoadingModal
    },


    methods: {

      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },

      limparFiltro(){
        this.search= ""
      },

      loadEmpresas() {
              let params = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`, 
                  "id_empresa": this.value_empresa.length > 0 ? this.value_empresa.map(e => e.id_empresa).join(',') : this.user.id_empresa,  // Verifica se há empresas e junta os ids como string
                  "id_filial": this.value_filial.length > 0 ? this.value_filial.map(f => f.id_filial_erp).join(',') : this.id_filial_erp,  // Verifica se há filiais e junta os ids como string             
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                           
            };
          const url = `${baseApiUrl}/ctr/empresa`
          axios.get(url,{params}).then(res => {
            this.empresasf = res.data.map(emp => {              
              return { id_empresa: emp.id_empresa, nomeempresarial: emp.nomeempresarial }
            })
          })
      },  
      
      loadFiliais() {
              let params = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`, 
                  "id_empresa": `${this.user.id_empresa}`, 
                  //"id_filial": this.value_filial.length > 0 ? this.value_filial.map(f => f.id_filial_erp).join(',') : this.id_filial_erp,  // Verifica se há filiais e junta os ids como string             
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                           
            };
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.get(url,{params}).then(res => {
            this.filiaisf = res.data.map(filial => {              
              return { id_filial_erp: filial.id_filial_erp, filial: filial.filial }        
            })
          })
      },

      loadEmpresaCad() {
              let params = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`, 
                  "id_empresa": this.value_empresa.length > 0 ? this.value_empresa.map(e => e.id_empresa).join(',') : this.user.id_empresa,  // Verifica se há empresas e junta os ids como string
                  "id_filial": this.value_filial.length > 0 ? this.value_filial.map(f => f.id_filial_erp).join(',') : this.id_filial_erp,  // Verifica se há filiais e junta os ids como string             
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                           
            };
          const url = `${baseApiUrl}/ctr/empresa`
          axios.get(url,{params})
          .then(res => {this.empresas = res.data.map(emp => {return { ... emp, value: emp.id_empresa, empresa: emp.nomeempresarial, id_filial_erp: emp.id_filial_erp } })})
          .catch(showError)
      },

      loadFiliaisCad() {
              let params = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`, 
                  "id_empresa": this.value_empresa.length > 0 ? this.value_empresa.map(e => e.id_empresa).join(',') : this.user.id_empresa,  // Verifica se há empresas e junta os ids como string
                  "id_filial": this.value_filial.length > 0 ? this.value_filial.map(f => f.id_filial_erp).join(',') : this.id_filial_erp,  // Verifica se há filiais e junta os ids como string             
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                           
            };

          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.get(url,{params})
            .then(res => {
              this.filiais = res.data.map(fil => {                      
                return { ... fil, value: fil.id_filial_erp, filial: fil.filial }  //// para pegar o valor tem que usar o ... atribuicao value
              })
            })
            .catch(showError)
      },

      loadTipos() {
                    let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                            
            };
          const url = `${baseApiUrl}/manutencao/corretiva/tipo`  
          axios.post(url,corpo).then(res => {
            this.tipos = res.data.map(tp => {              
              return { ... tp, value:  tp.id, tipo: tp.tipo, sos: tp.sos }              
            })            
          })          
      },

      

      loadLinhas() {
          let corpo = {    
              "id_empresa": `${this.corretiva.empresa_id}`,
              "id_filial": `${this.corretiva.filial_id}`                 
          };
          const url = `${baseApiUrl}/planejamento/linha/cad`
          axios.post(url,corpo)
            .then(res => {
              this.linhas = res.data.map(lin => {                      
                return { ... lin, value: lin.id_linha, linha: lin.linha }  //// para pegar o valor tem que usar o ... atribuicao value
              })
            })
            .catch(showError)
      },


      loadVeiculo() {
          let corpo = {    
              "id_empresa": `${this.corretiva.empresa_id}`,
              "prefixo": `${this.corretiva.carro}`                 
          };
          const url = `${baseApiUrl}/manutencao/frota/veiculo`
          axios.post(url,corpo)                      
          .then(res => { this.veiculos = res.data })                      
          .catch(showError)
        },



      loadVeiculoSocorrista() {
        let corpo = {    
          "id_empresa": `${this.corretiva.empresa_id}`,
              "prefixo": `${this.corretiva.carro_socorrista}`                 
          };
          const url = `${baseApiUrl}/manutencao/frota/veiculo`
          axios.post(url,corpo)
          .then(res => { this.socorrista_carro = res.data })                      
          .catch(showError)
      },

      loadVeiculoTrocado() {
        let corpo = {    
          "id_empresa": `${this.corretiva.empresa_id}`,
              "prefixo": `${this.corretiva.carro_trocado}`                 
          };
          const url = `${baseApiUrl}/manutencao/frota/veiculo`
          axios.post(url,corpo)
           .then(res => { this.trocado_carro = res.data })                      
          .catch(showError)
      },


      loadCep() {      
                  axios.get('https://viacep.com.br/ws/'+ this.corretiva.cep+'/json/').then(res => { this.viacep = res.data })
      },

      
      async loadOperador() { 
            let corpo = {                             
            "registro": `${this.corretiva.operador}`,
            "id_empresa": `${this.corretiva.empresa_id}`
            };             
          const url = `${baseApiUrl}/glo/escala/consulta`
          axios.post(url,corpo)
              .then(res => { this.operador = res.data })             
      },  

      async loadSocorrista() { 
            let corpo = {                             
            "registro": `${this.corretiva.socorrista}`,
            "id_empresa": `${this.corretiva.empresa_id}`
            };             
          const url = `${baseApiUrl}/glo/escala/consulta`
          axios.post(url,corpo)
              .then(res => { this.socorristas = res.data })             
      },
      
      async loadLider() { 
            let corpo = {                             
            "registro": `${this.defeito.lider}`,
            "id_empresa": `${this.corretiva.empresa_id}`
            };             
          const url = `${baseApiUrl}/glo/escala/consulta`
          axios.post(url,corpo)
              .then(res => { this.lideres = res.data })             
      },  

      async loadExecutante() { 
            let corpo = {                             
            "registro": `${this.defeito.executante}`,
            "id_empresa": `${this.corretiva.empresa_id}`
            };             
          const url = `${baseApiUrl}/glo/escala/consulta`
          axios.post(url,corpo)
              .then(res => { this.executantes = res.data })             
      },  


      loadGrupo_i() {      
            let corpo = {    
                "id_empresa": `${this.corretiva.empresa_id}`,                                            
            };    
          const url = `${baseApiUrl}/manutencao/corretiva/listagem/grupo`
          axios.post(url,corpo)
               .then(res => {this.gruposi = res.data.map(gru => {return { ... gru, value: gru.id_grupo, grupo: gru.grupo} })})
               .catch(showError)          
      },

      loadSubGrupo_i() {   
          let corpo = {    
                "id_empresa": `${this.corretiva.empresa_id}`,                                            
                "id_grupo": `${this.defeito.grupoi_id}`,                                            
          };          
          const url = `${baseApiUrl}/manutencao/corretiva/listagem/subgrupo`
          axios.post(url,corpo)
               .then(res => {this.subgruposi = res.data.map(sb => {return { ... sb, value: sb.id, subgrupo: sb.subgrupo} })})
               .catch(showError)
        },

        // 13/09/2023 criação
        loadDefeito_i() {   
          let corpo = {    
                "empresa_id": `${this.corretiva.empresa_id}`,                                            
                "grupo_id": `${this.defeito.grupoi_id}`,                                            
                "subgrupo_id": `${this.defeito.subgrupoi_id}`,                                            
          };          
          const url = `${baseApiUrl}/manutencao/corretiva/listagem/defeito`
          axios.post(url,corpo)                 
               .then(res => {this.defeitosi = res.data.map(de => {return { ... de, value: de.id, defeito: de.defeito} })})
//               .catch(showError)
        },


        //////////////////defeitos diagnosticados 13/09/2023 as 20:25h
        loadGrupo_d() {      
            let corpo = {    
                "id_empresa": `${this.corretiva.empresa_id}`,                                            
            };    
          const url = `${baseApiUrl}/manutencao/corretiva/listagem/grupo`
          axios.post(url,corpo)
               .then(res => {this.gruposd = res.data.map(gru => {return { ... gru, value: gru.id_grupo, grupo: gru.grupo} })})
                //.catch(showError)          
        },

        loadSubGrupo_d() {   
            let corpo = {    
                  "id_empresa": `${this.corretiva.empresa_id}`,                                            
                  "id_grupo": `${this.defeito.grupod_id}`,                                            
            };          
            const url = `${baseApiUrl}/manutencao/corretiva/listagem/subgrupo`
            axios.post(url,corpo)
                .then(res => {this.subgruposd = res.data.map(sb => {return { ... sb, value: sb.id, subgrupo: sb.subgrupo} })})
                //.catch(showError)
          },

          // 13/09/2023 criação
          loadDefeito_d() {   
            let corpo = {    
                  "empresa_id": `${this.corretiva.empresa_id}`,                                            
                  "grupo_id": `${this.defeito.grupod_id}`,                                            
                  "subgrupo_id": `${this.defeito.subgrupod_id}`,                                            
            };          
            const url = `${baseApiUrl}/manutencao/corretiva/listagem/defeito`
            axios.post(url,corpo)                 
                .then(res => {this.defeitosd = res.data.map(de => {return { ... de, value: de.id, defeito: de.defeito} })})
                //.catch(showError)
          },



      




      


























































    loadCorretivaStatus() {
          const url = `${baseApiUrl}/manutencao/corretiva/status`  
          axios.get(url).then(res => {
            this.statuss = res.data.map(st => {              
              return { ... st, value:  st.id_status, status: st.status }              
            })            
          })          
      },
      
      loadCorretivaStatusJb() {
          const url = `${baseApiUrl}/manutencao/corretiva/jbstatus`  
          axios.get(url).then(res => {
            this.situacaojb = res.data.map(jst => {              
              return { ... jst, value:  jst.id_jb_status, status: jst.jbstatus }              
            })            
          })          
      },


      loadNovoNroCorretiva() {
            const url = `${baseApiUrl}/manutencao/corretiva/nro`
            axios.get(url).then(res => {
              this.nrocorretiva = res.data.rows[0].nextval
            })
      },
        
      async postCabecalho() { 
            const dataAtual = new Date();
            let corpo = {                           
            "id": this.corretiva.id > 0 ?this.corretiva.id  : `${(this.nrocorretiva)}`,   
            "dt_cadastro": `${(this.corretiva.dt_cadastro)}`,  
            "dt_abertura" : dataAtual,
            "empresa_id": `${this.corretiva.empresa_id}`,
            "filial_id": `${this.corretiva.filial_id}`, 
            "carro_id": `${this.veiculos.map(at => at.id_veiculo).join(', ')}`,
            "tipo_id": `${this.corretiva.tipo_id}`,
            "id_funcionario": `${this.user.id_funcionario}`,
            "operador_id": this.operador.length != 0 ?  `${[this.operador.id_funcionario]}`: this.corretiva.operador_id,
            "linha_id": `${this.corretiva.linha_id}`,
            "cep": `${[this.corretiva.cep]}`,
            "logradouro": `${[this.viacep.logradouro]}`,
            "numero": `${[this.corretiva.numero]}`,
            "bairro": `${[this.viacep.bairro]}`,
            "cidade": `${[this.viacep.localidade]}`,
            "uf": `${[this.viacep.uf]}`,
            "socorrista_providencias": `${[this.corretiva.socorrista_obs]}`,
            "carro_trocado_id": this.trocado_carro.length != 0  ? `${[this.trocado_carro.map(v => v.id_veiculo)]}` : this.corretiva.carro_trocado_id,
            "socorrista_carro_id": this.socorrista_carro.length != 0  ? `${[this.socorrista_carro.map(v => v.id_veiculo)]}` : this.corretiva.socorrista_carro_id,           
            "socorrista_id": this.socorristas.length != 0  ? `${[this.socorristas.id_funcionario]}`: this.corretiva.socorrista_id,    
            "origem_id": 1,   // corretiva aberta na opção web
            "liberou_operacao": `${[this.corretiva.liberou_operacao]}`          
            }; 
          const url = `${baseApiUrl}/manutencao/corretiva/inscabecalho`
         axios.post(url,corpo).then(() => {
            this.postCorpo()                         
           })
           .catch(showError)
      },

        
        /////////atualizar corretiva para em serviço
        async encerrarCabecalho() { 
            let corpo = {  
            "id": this.nrocorretiva > 0 ? this.nrocorretiva : `${(this.corretiva.id)}`,               
            "funcionario_encerramento_id": `${this.user.id_funcionario}`,            
            //"fechamento": `${[4]}`,
            "status_id": `${[4]}`,
            "liberou_operacao": `${[true]}`   
            }; 
          const url = `${baseApiUrl}/manutencao/corretiva/encerrarcorretiva`
            axios.post(url,corpo).then(() => {   
              this.loadCorretivaMonitoramento()
              this.$toasted.global.defaultSuccess()  
              //this.limparCorpo()                             
           })
           .catch(showError)
        },

        /////////////////////////////////////////////////////////
        async postCorpo() { 
            let corpo = {                             
            "corretiva_id": this.corretiva.id > 0 ?this.corretiva.id  : `${(this.nrocorretiva)}`,   
            "id": `${this.defeito.id}`,
            "id_funcionario": `${this.user.id_funcionario}`,
            "empresa_id": `${this.corretiva.empresa_id}`,
            "filial_id": `${this.corretiva.filial_id}`,
            "dt_alteracao": `${this.defeito.dt_alteracao}`,
            "dt_cadastro": `${this.defeito.dt_cadastro}`,
            "grupoi_id": `${this.defeito.grupoi_id}`,
            "subgrupoi_id": `${this.defeito.subgrupoi_id}`,
            "defeitoi_id": `${this.defeito.defeitoi_id}`,
            "observacoes_i": `${[this.defeito.observacoes_i]}`,
            "lider_id": `${[this.lideres.id_funcionario]}`,
            "defeito_cancelado": `${[this.defeito.defeito_cancelado]}`,            
            "grupod_id": `${[this.defeito.grupod_id]}`,
            "subgrupod_id": `${[this.defeito.subgrupod_id]}`,
            "defeitod_id": `${[this.defeito.defeitod_id]}`,
            "observacoes_d": `${[this.defeito.observacoes_d]}` ,          
            "defeito_causador": `${[this.defeito.defeito_causador]}`,
            "executante_id": `${[this.executantes.id_funcionario]}`,
            
            }; 
          const url = `${baseApiUrl}/manutencao/corretiva/inscorpo`
          axios.post(url,corpo).then(() => {
              this.loadCorretivaAnalitica()            
              this.limparCorpo()               
              this.$toasted.global.defaultSuccess()                
                // this.loadCorretivaMonitoramento()                                 carregamento dentro da corretiva selecionada
           })
           .catch(showError)
        },


      


      ///////////////////////////////// 31/12/2022 as 20:17h
      editCorretivaCabecalho(corretiva){
            this.corretiva = { ...corretiva }            
            //this.editCorretivaCorpo()
            this.loadFiliais()
            this.loadCorretivaAnalitica() 
            this.loadFiliaisCad()
            this.loadOperador()
            this.loadTipos()
            this.loadLinhas()
            this.loadSocorrista()
            this.loadVeiculo()
            this.loadVeiculoSocorrista()
            this.loadVeiculoTrocado()
            //this.loadCep()
            
      },

      editCorretivaCorpo(defeito){
            this.defeito = { ...defeito }
            
            this.loadGrupo_i()
            this.loadSubGrupo_i()
            this.loadDefeito_i()
            this.loadGrupo_d()
            this.loadSubGrupo_d()
            this.loadDefeito_d()           
            

//            this.loadSolicitante()
//            this.loadLider()
//            this.loadExecutante()
            
      },

      loadCorretivaMonitoramento() { 
        this.isLoading = true; // Desative o indicador de carregamento                          
          let corpo = {    
               "empresa_id": `${[this.user.id_empresa]}`,                            
               "filial_id": `${[this.filiaisf.map(f => f.id_filial_erp)]}`,                                            
               "status_id": `${[this.value_status.map( s => s.id)]}`,        
               "tipo_id": this.value_tipo !=null ? `${[this.value_tipo.map(t => t.id)]}`: null,
               "dt_abertura": this.dt_abertura  !=null ? `${[this.dt_abertura]}`: null                
                //"dt_inicial": `${this.dt_abertura + ' 00:00:01.000 -0300'}`,                                            
                //"dt_final": `${this.dt_abertura + ' 23:59:59.000 -0300'}`, 
          };
          const url = `${baseApiUrl}/manutencao/corretiva/monitoramento`
          axios.post(url,corpo).then(res => { 
            this.corretivas = res.data    
            this.isLoading = false; // Desative o indicador de carregamento                  
          })
          .catch(showError)         
      },

      loadCorretivaAnalitica() { 
          let corpo = {    
              "empresa_id":   `${[this.corretiva.empresa_id]}`,            
              "corretiva_id": this.corretiva.id ? this.corretiva.id : `${[this.nrocorretiva]}`,                       
          };
          const url = `${baseApiUrl}/manutencao/corretiva/analitica`
          axios.post(url,corpo).then(res => { 
            this.corretivaeditdefeito = res.data             
          })
          .catch(showError)         
      },


      
      reset() {
          this.postCabecalho()
      },

      limparCorpo(){
        this.defeito =[]        
        this.executante=[]
       this.lider=[]        
       this.value_executante=''
        this.value_lider=''
        ///this.nrocorretiva=[]  // precisa limpar somente ao fechar ou quando cria-se uma nova ficha
      },

      novo(){
        this.corretiva = {}
        this.defeito = {}                
        this.corretivaeditdefeito = {}
        //this.loadNovoNroCorretiva()
        //this.loadCorretivaMonitoramento()
      }
       
    },
    
    mounted() {   
      this.loadFiliais()
      this.loadCorretivaStatus()
      this.loadTipos() 
      this.loadCorretivaMonitoramento()
      /*
      this.loadEmpresaCad() 
      this.loadEmpresas()      
      */
          //27/12/2022 as 18:00           -        12/09/2023 as 14:23
       //this.loadCorretivaMonitoramento(); // Chama o método inicialmente
    // Define um observador para a propriedade `corretivas`
    /*
    this.$watch('corretivas', (newValue, oldValue) => {
        // Aqui, newValue é o novo valor de corretivas, e oldValue é o valor anterior
        // Você pode chamar o método loadCorretivaMonitoramento aqui ou qualquer outra ação que você queira executar quando corretivas mudar
        this.loadCorretivaMonitoramento();
    }, { deep: true }); // Observa mudanças profundas no objeto
*/
      /*   
      this.loadCorretivaStatusJb() 
      this.loadGrupoInformado()
      this.loadGrupoDiagnosticado()
      */
      
    },
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#placa{
    font-size: 0.7em;      
}

#modal-multi-corretiva___BV_modal_content_{
  background: rgb(227, 236, 227);
  /* border: 1px solid rgb(58, 20, 196) ; */
  border-radius: 8px;
  margin-bottom: 4px;  
}


#defeito-selecao{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196) ;
  border-radius: 8px;
  margin-bottom: 4px;  
}

#id-sos{  
  background: rgb(199, 222, 218);
  border: 1px solid red ;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-informado{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196) ;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-diagnosticado{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2) ;
  border-radius: 8px;
  margin-bottom: 4px;  
  
}

#id-encerramento{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2) ;
  border-radius: 8px;
  margin-bottom: 4px;  
  
}

#corretiva-nro{
  color: rgb(240, 8, 8);
  font-size: 18px;
  text-align: center;
  
}



#garagem{  
  font-size: 12px;
  text-align: center;
  
}





</style>